import React, { useContext, useEffect, useState } from 'react';
import utilsTblOrders from '../../../../MyConns/_Utils/utilsTblOrders';
import { WaitingToApprovContext } from '../../../MyContexts/WaitingToApprov_Context';
import MyDateTime from '../../../MySections/TimeSections/MyDateTime';
import TblOrderStatuselect from './TblOrderStatuselect';
import ShowTableOrder from './showTableOrder';

const ListTblOrdersTable = (props) => {
    const [wToImpto, setWToImpto, checkIfItemExistsAndStatus] = useContext(WaitingToApprovContext);
    
    const [thePopUp, setThePopUp] = useState("");


    useEffect(() => {

    }, [])

    const orderBythis = (byWhat) => {
        props.orderBythis(byWhat);
    }
    const rowCellClick = (ordId) => {

        setThePopUp(<ShowTableOrder
            ordId={ordId}
            cancelClick={() => setThePopUp()}
            ordrApproved={() => { props.refreshTheList(); setThePopUp() }}
        />)

    }

    const setNewStatus = async (orderId, statBack) => {
        let updteme = await utilsTblOrders.updateTableStatus(orderId, statBack);

        checkIfItemExistsAndStatus({ _id: orderId, status: statBack });

        props.refreshTheList();
    }

    return (
        <div className="row lstOrderTbls">
            <div className="col-xl-12">
                <div className="table-responsive ms-panel-body">
                    <table className="table table-hover thead-primary">
                        <thead>
                            <tr>
                                <th scope="col" className={"pointing"} onClick={() => orderBythis("orderNUM")}>הזמנה</th>
                                <th scope="col" className={"pointing"} onClick={() => orderBythis("dateCreated")}>הוזמן ב</th>
                                <th scope="col" className={"pointing"} onClick={() => orderBythis("clientName")}>שם הלקוח</th>
                                <th scope="col" className={"pointing"} onClick={() => orderBythis("clientPhone")}>טלפון</th>
                                <th scope="col" className={"pointing"} onClick={() => orderBythis("dinners")}>סועדים</th>
                                <th scope="col" className={"pointing"} onClick={() => orderBythis("timeToCome")}>שעת הגעה</th>
                                <th scope="col" className={"pointing"} onClick={() => orderBythis("dateToCome")}>תאריך הגעה</th>
                                <th scope="col" className={"pointing"} onClick={() => orderBythis("DayToCome")}>יום</th>
                                <th scope="col" className={"pointing"} onClick={() => orderBythis("status")}>סטטוס</th>
                                <th scope="col" className={"pointing"} onClick={() => orderBythis("remarks")}>הערות</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                props.theList.map((item, i) => (
                                    <tr key={item._id} className={"pointing"} itmid={item._id}>
                                        <td onClick={() => rowCellClick(item._id)}><p>{item.tblOrderNum}</p></td>
                                        <td onClick={() => rowCellClick(item._id)}><p>{MyDateTime.getDateAndTime(item.dateCreated)}</p></td>
                                        <td onClick={() => rowCellClick(item._id)}><p className='bold'>{item.clientName}</p></td>
                                        <td onClick={() => rowCellClick(item._id)}><p className='bold'>{item.clientPhone}</p></td>
                                        <td onClick={() => rowCellClick(item._id)}><p className='bold'>{item.dinners}</p></td>
                                        <td onClick={() => rowCellClick(item._id)}><p className='bold'> {item.timeToCome}</p></td>
                                        <td onClick={() => rowCellClick(item._id)}><p className='bold'> {MyDateTime.getDate(item.dateToCome)}</p></td>
                                        <td onClick={() => rowCellClick(item._id)}><p className='bold'> {MyDateTime.getDayOfWeekHeb(item.dateToCome)}</p></td>
                                        <td className={"statusCell pointing"} >
                                            <TblOrderStatuselect orderStatus={item.status}
                                                setOrderStatus={(statBack) => setNewStatus(item._id, statBack)}
                                            />
                                        </td>
                                        <td onClick={() => rowCellClick(item._id)}><p>{item.remarks != "" ? "יש" : "אין"}</p></td>
                                    </tr>
                                ))
                            }

                        </tbody>
                    </table>
                </div>
            </div>
            {thePopUp}
        </div>
    )
}

export default ListTblOrdersTable;